<template>
    <article class="level is-mobile">
        <div class="level-right">
            <div class="level-item">
                <p :data-tooltip="user.name" class="image is-24x24 has-tooltip-bottom">
                    <img :src="user.avatar" referrerpolicy="no-referrer" class="is-rounded" />
                </p>
                <div>
                    <p
                        v-if="showName"
                        class="lb-mini-profile-title lb-alternative-font has-text-weight-bold has-text-grey"
                    >{{ user.alias || user.name || user.username }}</p>
                    <p v-if="showSchool && user.school">{{ user.school.name }}</p>
                </div>
            </div>
            <!--div class="level-item">
        <p class="image is-24x24">
          <img 
            :src="user.avatar" 
            class="is-rounded" />
        </p>
            </div-->
        </div>
    </article>
</template>

<script>
export default {
    props: {
        user: { type: Object, default: () => {} },
        showSchool: { type: Boolean, default: false },
        showName: { type: Boolean, default: true },
    },
};
</script>

<style scoped>
.image {
    margin: 0.5rem;
}
</style>
